import React from "react";

class FaderLogo extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451.42 141.31">
        <title>fader-logo</title>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path d="M173.07,21.31H154.74L121.32,120h19.74l7.19-23.27h31.31L186.75,120h19.74Zm-19.6,58.51L163.9,45.56l10.44,34.26Z" />
            <path d="M246.74,21.31H215.86V120h30.88c20,0,41.06-14.81,41.06-49.35S266.78,21.31,246.74,21.31ZM241,103.09h-6.77V38.23H241c15.5,0,28.43,6.2,28.43,32.43S256.46,103.09,241,103.09Z" />
            <path d="M424.07,79.87c12-3.66,18.47-15.53,18.47-28.5,0-16.36-10.29-30.06-30-30.06h-36V120h18.33V81.42h9.59L431,120h20.44ZM412.65,64.5H394.88V38.23h17.77c6.63,0,11.56,5.1,11.56,13.14S419.28,64.5,412.65,64.5Z" />
            <path d="M0,0V141.31H112.15V0ZM90.85,40.13H42.55V60.79H82.19V79.61H42.55V120H21.26V21.31H90.85Z" />
            <polygon points="300.41 21.31 300.41 120.01 362.88 120.01 362.88 103.09 318.74 103.09 318.74 75.87 352.76 75.87 352.76 58.95 318.74 58.95 318.74 38.23 361.47 38.23 361.47 21.31 300.41 21.31" />
          </g>
        </g>
      </svg>
    );
  }
}

export default FaderLogo;
